// Shared menu configuration for sidebar and role management
// This ensures menu items are consistent across the app

import DashboardIcon from '@mui/icons-material/Dashboard';
import CarIcon from '@mui/icons-material/DirectionsCar';
import ExitIcon from '@mui/icons-material/ExitToApp';
import OfferIcon from '@mui/icons-material/LocalOffer';
import CollectionsIcon from '@mui/icons-material/Collections';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import NotifyIcon from '@mui/icons-material/NotificationsActive';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ViewListIcon from '@mui/icons-material/ViewList';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MoneyIcon from '@mui/icons-material/Money';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import SosIcon from '@mui/icons-material/Sos';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import SecurityIcon from '@mui/icons-material/Security';
import MessageIcon from '@mui/icons-material/Message';
import {calcEst, showEst, optionsRequired} from '../common/sharedFunctions';

export const getMenuItems = (t) => [
  {name : t('dashboard_text'), url:'/dashboard', icon: <DashboardIcon/>, key: 'dashboard', access: ['admin','fleetadmin']},
  {name : t('booking_history'), url:'/bookings', icon: <ViewListIcon/>, key: 'bookings', access: ['admin','fleetadmin','driver','customer']},
  {name : t('addbookinglable'), url:'/addbookings', icon: <ContactPhoneIcon/>, key: 'add_booking', access: calcEst && !showEst && !optionsRequired ? ['customer'] : ['admin','fleetadmin','customer']},
  {name : t('user'), url:'/users/0', icon: <EmojiPeopleIcon />, key: 'users', access: ['admin','fleetadmin'], 
    sub_permissions: {
      riders: {name: t('riders'), key: 'users_riders', access: ['admin','fleetadmin']},
      drivers: {name: t('drivers'), key: 'users_drivers', access: ['admin','fleetadmin']},
      fleetadmins: {name: t('fleetadmins'), key: 'users_fleetadmins', access: ['admin']},
      alladmin: {name: t('alladmin'), key: 'users_alladmin', access: ['admin']}
    }
  },
  {name : t('car_type'), url:'/cartypes', icon: <CarIcon/>, key: 'cartypes', access: ['admin']},
  {name : t('cars'), url:'/cars', icon: <CarIcon/>, key: 'cars', access: ['admin','fleetadmin','driver']},
  {name : t('withdraws_web'), url:'/withdraws', icon: <MoneyIcon />, key: 'withdraws', access: ['admin']},
  {name : t('add_to_wallet'), url:'/addtowallet', icon: <AccountBalanceWalletIcon />, key: 'add_to_wallet', access: ['admin']},
  {name : t('report'), url:'/allreports', icon: <AssessmentIcon />, key: 'reports', access: ['admin','fleetadmin'],
    sub_permissions: {
      driver_earning: {name: t('driver_earning'), key: 'reports_driver_earning', access: ['admin','fleetadmin']},
      earning_reports: {name: t('earning_reports'), key: 'reports_earning_reports', access: ['admin']},
      fleetadmin_earning: {name: t('fleetadmin_earning_reports'), key: 'reports_fleetadmin_earning', access: ['admin']}
    }
  },
  {name : t('promo'), url:'/promos', icon: <OfferIcon />, key: 'promo', access: ['admin']},
  {name : 'Banners', url:'/banners', icon: <CollectionsIcon />, key: 'banners', access: ['admin']},
  {name : 'Fare Rules', url:'/farerules', icon: <PriceChangeIcon />, key: 'fare_rules', access: ['admin']},
  {name : t('push_notifications'), url:'/notifications', icon: <NotifyIcon />, key: 'notifications', access: ['admin']},
  {name : t('sos'), url:'/sos', icon: <SosIcon />, key: 'sos', access: ['admin']},
  {name : t('complain'), url:'/complain', icon: <AnnouncementOutlinedIcon/>, key: 'complain', access: ['admin']},
  {name : t('my_wallet_tile'), url:'/userwallet', icon: <AccountBalanceWalletIcon />, key: 'wallet', access: ['driver','customer','fleetadmin']},
  {name : t('settings_title'), url:'/settings', icon: <PhoneIphoneIcon />, key: 'settings', access: ['admin']},
  {name : t('payment_settings'), url:'/paymentsettings', icon: <PhoneIphoneIcon />, key: 'payment_settings', access: ['admin']},
  {name : t('msg91_templates'), url:'/msg91templates', icon: <MessageIcon />, key: 'msg91_templates', access: ['admin']},
  {name : 'Role Management', url:'/rolemanagement', icon: <SecurityIcon />, key: 'role_management', access: ['admin']},
  {name : t('profile'), url:'/profile', icon: <AccountCircleIcon />, key: 'profile', access: ['admin','fleetadmin','driver','customer']},
  {name : t('logout'), url:'logout', icon: <ExitIcon />, key: 'logout', access: ['admin','fleetadmin','driver','customer']}
];
